export const deleteGenericDocuments = {
    source: 'app',
    route: '/document/deleteDocuments',
    method: 'DELETE',
};
